import { useEffect, useState } from "react";

export default () => {
  const [vhUpdated, setVhUpdate] = useState(window.innerHeight * 0.01);

  useEffect(() => {
    window.addEventListener("resize", () =>
      setVhUpdate(window.innerHeight * 0.01)
    );
  }, [vhUpdated]);

  return [{ vhUpdated }];
};
